import * as React from 'react'

import { Page } from '@webapp/core/components/Page'
import { useProcurifyIntl } from '@webapp/hooks'
import { useAppRoutes } from '@webapp/hooks/useAppRoutes'
import { ContractListPageStatuses } from './ContractListPage'
import messages from './messages'

export interface ContractCreatePageParams {
  uuid: string
}

const ContractCreateAIViewChunk = React.lazy(() =>
  import('../containers/ContractCreateView/ContractCreateAIView').then(
    ({ ContractCreateAIView }) => ({
      default: ContractCreateAIView,
    })
  )
)

export const ContractCreatePage = () => {
  const intl = useProcurifyIntl()

  const { url } = useAppRoutes()

  return (
    <Page
      pageTitle={intl.formatMessage(messages.contractCreateTitle)}
      breadcrumbs={[
        {
          name: intl.formatMessage(messages.contractListTitle),
          link: url('ContractListPage', {
            status: ContractListPageStatuses.ACTIVE,
          }),
        },
        {
          name: intl.formatMessage(messages.contractCreateTitle),
        },
      ]}
    >
      <ContractCreateAIViewChunk />
    </Page>
  )
}
